import { apiRequest } from "./index";

export const signInRequest = ( data, success = (result = []) => {}, failure = error => {} ) => {
    apiRequest(
        '/auth/signin', 
        {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data),
        },
        success,
        failure
    );
}
